import React from "react";

import styles from "./OrderDetailsSection.module.scss";

interface Props {
  phone: string;
  comment: string;
  getValidationResult: (fieldName: string) => { notValid?: boolean; message?: string } | undefined;
  inputHandler: (value: string, fieldName: "phone" | "comment") => void;
  setDirty: (fieldName: string) => void;
  maxCommentLength: number;
}

export const OrderDetailsSection: React.FC<Props> = ({
  phone,
  comment,
  getValidationResult,
  inputHandler,
  setDirty,
  maxCommentLength,
}) => {
  const phoneValidation = getValidationResult("phone");
  const commentValidation = getValidationResult("comment");

  return (
    <div className={styles.Container}>
      <h3 className={styles.Title}>Контактные данные</h3>

      <label className={styles.Field}>
        <span className={styles.Label}>Телефон *</span>
        <input
          className={`${styles.Input} ${phoneValidation?.notValid ? styles.Invalid : ""}`}
          type="tel"
          value={phone}
          placeholder="+7 (999) 123-45-67"
          onChange={(e) => inputHandler(e.target.value, "phone")}
          onBlur={() => setDirty("phone")}
        />
        {phoneValidation?.notValid && phoneValidation.message && (
          <span className={styles.Error}>{phoneValidation.message}</span>
        )}
      </label>

      <label className={styles.Field}>
        <span className={styles.Label}>Комментарий к заказу</span>
        <textarea
          className={`${styles.Textarea} ${commentValidation?.notValid ? styles.Invalid : ""}`}
          value={comment}
          rows={3}
          onChange={(e) => inputHandler(e.target.value, "comment")}
          onBlur={() => setDirty("comment")}
          maxLength={maxCommentLength}
        />
        <span className={styles.Counter}>
          {comment.length}/{maxCommentLength}
        </span>
        {commentValidation?.notValid && commentValidation.message && (
          <span className={styles.Error}>{commentValidation.message}</span>
        )}
      </label>
    </div>
  );
};